(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-intl"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar__swiper', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    watchOverflow: true,
    navigation: {
      prevEl: '.announcement-bar .swiper-button-prev',
      nextEl: '.announcement-bar .swiper-button-next'
    },
    speed: 600,
    autoplay: {
      delay: 4000
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar__swiper', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    watchOverflow: true,
    navigation: {
      prevEl: '.announcement-bar .swiper-button-prev',
      nextEl: '.announcement-bar .swiper-button-next'
    },
    speed: 600,
    autoplay: {
      delay: 4000
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-slider"] && !Shopify.designMode) return;
  try {
    
  const brandsSlider = new Swiper('.brands-slider__slider', {
    slidesPerView: 2,
    slidesPerGroup: 2,
    loop: true,
    spaceBetween: 15,
    allowTouchMove: true,
    navigation: {
      nextEl: '.brands-slider__buttons .swiper-button-next'
    },
    pagination: {
      el: '.brands-slider__pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 20,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-blocks"] && !Shopify.designMode) return;
  try {
    
  const collectionBlocksSlider = new Swiper('.collection-blocks__container', {
    slidesPerView: 1.4,
    loop: true,
    spaceBetween: 15,
    centeredSlides: true,
    allowTouchMove: true,
    threshold: 15,
    pagination: {
      el: '.collection-blocks__pagination', 
      clickable: true
    },
    breakpoints: {
      525: {
        slidesPerView: 2,
        loop: true
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-featured-articles"]) return;
  try {
    
  const featuredArticlesSlider = new Swiper('.featured-articles__container', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20, 
    allowTouchMove: true,
    pagination: {
      el: '.featured-articles__pagination',
      type: 'fraction'
    },
    navigation: {
      prevEl: '.featured-articles .swiper-button-prev',
      nextEl: '.featured-articles .swiper-button-next'
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-blocks-v2"] && !Shopify.designMode) return;
  try {
    
const ctaBlocksSlider = new Swiper('.cta-blocks-v2__container', {
  slidesPerView: 1.15,
  loop: false,
  spaceBetween: 10,
  allowTouchMove: true,
  pagination: {
    el: '.cta-blocks-v2__pagination',
    clickable: true
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
      centeredSlides: false,
      loop: false,
      allowTouchMove: false
    } 
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curated-edits"] && !Shopify.designMode) return;
  try {
    
  const showMoreButton = document.querySelector('.curated-edits__show-more');
  if (showMoreButton) {
    showMoreButton.addEventListener('click', event => {
      showMoreButton.remove(); 
      document.querySelector('.curated-edits__more').style.display = 'grid';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-protect"] && !Shopify.designMode) return;
  try {
    
  const allSections = document.querySelectorAll('#MainContent .shopify-section');
  const pwWrapper = document.querySelector('.password-wrapper');
  const cookieName = pwWrapper.dataset.section;

  if (!getCookie(cookieName)) {
    pwWrapper.classList.remove('hidden');
    toggleSections('hide');
  }

  function toggleSections(toggle) {
    allSections.forEach(section => {
      if (!section.classList.contains('password')) {
        if (toggle == 'hide') {
          section.classList.add('hidden');
        } else {
          section.classList.remove('hidden');
        }
      }
    });
  }

  // On button click
  setTimeout(function(){
    const button = document.querySelector('.klaviyo-form-UKXfTh button');
    const emailInput = document.querySelector('.klaviyo-form-UKXfTh input')
    function validateEmail(inputText) {
      var mailFormat =  /\S+@\S+\.\S+/;
      if (inputText.value.match(mailFormat)) {
        return true;
      } else {
        return false;
      }
    }
    
    button.addEventListener('click', event => {
      if(validateEmail(emailInput)){
        toggleSections('show');
        pwWrapper.classList.add('hidden');
  
        var now = new Date();
        now.setTime(now.getTime() + 1 * (120 * 60) * 1000);
        setCookie(cookieName, true, now);
      }
    });
  }, 1000)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-articles"] && !Shopify.designMode) return;
  try {
    
  const featuredArticlesSlider = new Swiper('.featured-articles__container', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20, 
    allowTouchMove: true,
    pagination: {
      el: '.featured-articles__pagination',
      type: 'fraction'
    },
    navigation: {
      prevEl: '.featured-articles .swiper-button-prev',
      nextEl: '.featured-articles .swiper-button-next'
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Mobile dropdowns
  const headerItems = document.querySelectorAll('.footer__heading-mobile');

  headerItems.forEach(header => {
    header.addEventListener('click', event => {
      const parent = header.parentElement;
      const content = header.nextElementSibling;

      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(content, 400);
      } else {
        parent.classList.add('active');
        slideDown(content, 400);
      }
    });
  });

  // Credits
  const creditsButtons = document.querySelectorAll('a[href="#credits"]');
  const creditsCloseButtons = document.querySelectorAll('.site-credits__close');
  const credits = document.querySelector('.site-credits');

  creditsButtons.forEach(creditsButton => {
    creditsButton.addEventListener('click', event => {
      event.preventDefault();
      credits.classList.add('is-visible');

      document.addEventListener('keydown', function(event){
        if (event.key === "Escape") {
          credits.classList.remove('is-visible');
        }
      });
    });
  });

  creditsCloseButtons.forEach(creditsCloseButton => {
    creditsCloseButton.addEventListener('click', event => {
      credits.classList.remove('is-visible');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Megamenu Overlay
  const menuItems = document.querySelectorAll('.header__mega-menu-wrapper');
  const pageOverlay = document.querySelector('.page-overlay-under-menu');
  menuItems.forEach(menuItem => {
    menuItem.addEventListener('mouseenter', event => {
      pageOverlay.classList.add('is-visible');
    });
  
    menuItem.addEventListener('mouseleave', event => {
      pageOverlay.classList.remove('is-visible');
    });
  });

  // Search
  const search = document.querySelector('.header__search');
  const searchButton = document.querySelector('.header__search-button');
  searchButton.addEventListener('click', event => {
    event.stopPropagation();
    search.classList.add('active');
  });

  const mobileSearch = document.querySelector('.header-mobile-search');
  const mobileSearchButton = document.querySelector('.js-open-mobile-search');
  mobileSearchButton.addEventListener('click', event => {
    event.stopPropagation();
    mobileSearch.classList.add('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  const legalPopup = document.querySelector('.legal-popup');
  const legalPopupCloseButtons = document.querySelectorAll('.legal-popup__close');

  if (getCookie('legalCookie')) {
    legalPopup.classList.remove('is-visible');
  } else {
    legalPopup.classList.add('is-visible');
  }

  legalPopupCloseButtons.forEach(legalPopupClose => {
    legalPopupClose.addEventListener('click', event => {
      const day = legalPopup.dataset.day;
  
      legalPopup.classList.remove('is-visible');
      setCookie('legalCookie', true, day);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locations"] && !Shopify.designMode) return;
  try {
    
console.log('adfssda')
  var locationSliders = [];
  [...document.querySelectorAll('.locations__image-slider')].forEach((el, i) => {
    var slider = `.locations__image-slider[data-idx="${el.dataset.idx}"]`;
    var pagination = `.locations__pagination[data-idx="${el.dataset.idx}"]`;

    locationSliders[i] = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow:  true,
      allowTouchMove: true,
      pagination: {
        el: pagination,
        clickable: true
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-header"] && !Shopify.designMode) return;
  try {
    
  const headerContentSlider = new Swiper('.blog-header__content', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      prevEl: '.blog-header .swiper-button-prev',
      nextEl: '.blog-header .swiper-button-next'
    },
    pagination: {
      el: '.blog-header__pagination',
      type: 'fraction'
    },
    speed: 600
  });

  const headerImageSlider = new Swiper('.blog-header__images', {
    slidesPerView: 1,
    loop: true,
    speed: 600,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    }
  });

  // Sync content with image
  headerContentSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    headerImageSlider.slideToLoop(idx);
  });

  // Sync image with content
  headerImageSlider.on('slideChange', slider => {
    let idx = slider.realIndex;

    headerContentSlider.slideToLoop(idx);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  const container = document.querySelector('.customer-gate');
  const login = document.querySelector('[href="#login"]');
  const recover = document.querySelector('[href="#recover"]');
  login.addEventListener('click', event => container.classList.remove('forgot-active'));
  recover.addEventListener('click', event => container.classList.add('forgot-active'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundle"]) return;
  try {
    
  // Initial slide
  let initialSlide = Number(document.querySelector('.product__media-list').dataset.initial) - 1 || 0;
  if (initialSlide < 0) initialSlide = 0; 

  // Product sliders
  const thumbList = document.querySelector('.product__thumbnail-list');
  const thumbs = document.querySelectorAll('.product__thumbnail-item');
  
  const productThumbsSlider = new Swiper('.product__thumbnail-list', {
    slidesPerView: 'auto',
    // loop: true,
    spaceBetween: 0,
    initialSlide: initialSlide,
    grabCursor: true, 
    direction: 'vertical',
    // allowTouchMove: false,
    watchSlidesProgress: true,
    threshold: 10,
    navigation: {
      nextEl: '.product__thumbnail-buttons .swiper-button-next'
    }
  });

  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1.05,
    // loop: true,
    spaceBetween: 13,
    initialSlide: initialSlide,
    allowTouchMove: true,
    thumbs: {
      swiper: productThumbsSlider
    },
    pagination: {
      el: '.product__media-pagination',
      clickable: true
    },
    breakpoints: {
      851: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        allowTouchMove: false,
      }
    }
  }); 

  // Hacks
  if (thumbs) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', event => {
        const idx = Number(thumb.dataset.idx);
        console.log('asdflahjkda')
        productSlider.slideTo(idx); 
      });
    })
  }

  let reset = false;
  
  // document.querySelector('.product__thumbnail-buttons .swiper-button-next').addEventListener('click', event => {
  //   console.log('click')
  //   if (event.currentTarget.disabled) {
  //     event.currentTarget.setAttribute('disabled', false);
  //     event.currentTarget.classList.remove('swiper-button-disabled');
  //     reset = true;
  //   } else {
  //     if (reset) {
  //       console.log('in')
  //       productThumbsSlider.setProgress(0); 
  //     } else {
  //       reset = false;
  //     }
  //   }
  // });


  // let thumbCount = Number(thumbList.dataset.count);
  // let thumbFit = thumbList.offsetHeight / 87;

  // if (thumbCount < thumbFit) {
  //   thumbList.classList.add('locked');
  // }

  // window.addEventListener('resize', event => {
  //   thumbCount = Number(thumbList.dataset.count);
  //   thumbFit = thumbList.offsetHeight / 87;
    
  //   if (thumbCount < thumbFit) {
  //     thumbList.classList.add('locked');
  //   } else {
  //     thumbList.classList.remove('locked');
  //   }
  // });

  window.productSlider = productSlider;

  
  // Product zoom slider
  const productZoomSlider = new Swiper('.product__zoom-slider', {
    loop: true,
    allowTouchMove: true,
    navigation: {
      prevEl: '.product__zoom-button.swiper-button-prev',
      nextEl: '.product__zoom-button.swiper-button-next',
    },
    breakpoints: {
      769: {
        allowTouchMove: false,
      }
    }
  });

  const zoomContainer = document.querySelector('.product__zoom');
  const zoomButtons = document.querySelectorAll('.product__media-zoom');
  zoomButtons.forEach(zoomButton => {
    zoomButton.addEventListener('click', event => {
      const position = Number(event.currentTarget.dataset.position) - 1;
      productZoomSlider.slideToLoop(position);

      setTimeout(() => {
        zoomContainer.classList.add('open');
        document.body.classList.add('scroll-lock');

        document.body.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') {
            zoomContainer.classList.remove('open');
            document.body.classList.remove('scroll-lock');
          }
        });
      }, 250);
    });
  });

  const zoomWrapper = document.querySelector('.product__zoom-slider-wrapper');
  zoomWrapper.addEventListener('click', event => {
    zoomContainer.classList.remove('open');
    document.body.classList.remove('scroll-lock');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Initial slide
  let initialSlide = Number(document.querySelector('.product__media-list').dataset.initial) - 1 || 0;
  if (initialSlide < 0) initialSlide = 0; 

  // Product sliders
  const thumbList = document.querySelector('.product__thumbnail-list');
  const thumbs = document.querySelectorAll('.product__thumbnail-item');
  
  const productThumbsSlider = new Swiper('.product__thumbnail-list', {
    slidesPerView: 'auto',
    // loop: true,
    spaceBetween: 0,
    initialSlide: initialSlide,
    grabCursor: true, 
    direction: 'vertical',
    // allowTouchMove: false,
    watchSlidesProgress: true,
    threshold: 10,
    navigation: {
      nextEl: '.product__thumbnail-buttons .swiper-button-next'
    }
  });

  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1.05,
    // loop: true,
    spaceBetween: 13,
    initialSlide: initialSlide,
    allowTouchMove: true,
    thumbs: {
      swiper: productThumbsSlider
    },
    pagination: {
      el: '.product__media-pagination',
      clickable: true
    },
    breakpoints: {
      851: {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        allowTouchMove: false,
      }
    }
  }); 

  // Hacks
  if (thumbs) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', event => {
        const idx = Number(thumb.dataset.idx);
        console.log('asdflahjkda')
        productSlider.slideTo(idx); 
      });
    })
  }

  let reset = false;
  
  // document.querySelector('.product__thumbnail-buttons .swiper-button-next').addEventListener('click', event => {
  //   console.log('click')
  //   if (event.currentTarget.disabled) {
  //     event.currentTarget.setAttribute('disabled', false);
  //     event.currentTarget.classList.remove('swiper-button-disabled');
  //     reset = true;
  //   } else {
  //     if (reset) {
  //       console.log('in')
  //       productThumbsSlider.setProgress(0); 
  //     } else {
  //       reset = false;
  //     }
  //   }
  // });


  // let thumbCount = Number(thumbList.dataset.count);
  // let thumbFit = thumbList.offsetHeight / 87;

  // if (thumbCount < thumbFit) {
  //   thumbList.classList.add('locked');
  // }

  // window.addEventListener('resize', event => {
  //   thumbCount = Number(thumbList.dataset.count);
  //   thumbFit = thumbList.offsetHeight / 87;
    
  //   if (thumbCount < thumbFit) {
  //     thumbList.classList.add('locked');
  //   } else {
  //     thumbList.classList.remove('locked');
  //   }
  // });

  window.productSlider = productSlider;

  
  // Product zoom slider
  const productZoomSlider = new Swiper('.product__zoom-slider', {
    loop: true,
    allowTouchMove: true,
    navigation: {
      prevEl: '.product__zoom-button.swiper-button-prev',
      nextEl: '.product__zoom-button.swiper-button-next',
    },
    breakpoints: {
      769: {
        allowTouchMove: false,
      }
    }
  });

  const zoomContainer = document.querySelector('.product__zoom');
  const zoomButtons = document.querySelectorAll('.product__media-zoom');
  zoomButtons.forEach(zoomButton => {
    zoomButton.addEventListener('click', event => {
      const position = Number(event.currentTarget.dataset.position) - 1;
      productZoomSlider.slideToLoop(position);

      setTimeout(() => {
        zoomContainer.classList.add('open');
        document.body.classList.add('scroll-lock');

        document.body.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') {
            zoomContainer.classList.remove('open');
            document.body.classList.remove('scroll-lock');
          }
        });
      }, 250);
    });
  });

  const zoomWrapper = document.querySelector('.product__zoom-slider-wrapper');
  zoomWrapper.addEventListener('click', event => {
    zoomContainer.classList.remove('open');
    document.body.classList.remove('scroll-lock');
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-protect"] && !Shopify.designMode) return;
  try {
    
  const allSections = document.querySelectorAll('#MainContent .shopify-section');
  const pwWrapper = document.querySelector('.password-wrapper');
  const cookieName = pwWrapper.dataset.section;

  if (!getCookie(cookieName)) {
    pwWrapper.classList.remove('hidden');
    toggleSections('hide');
  }

  function toggleSections(toggle) {
    allSections.forEach(section => {
      if (!section.classList.contains('password')) {
        if (toggle == 'hide') {
          section.classList.add('hidden');
        } else {
          section.classList.remove('hidden');
        }
      }
    });
  }

  // On button click
  const button = document.querySelector('.password-protect__button');
  const input = document.querySelector('.password-protect__input');
  const password = input.dataset.pw.toLowerCase();

  button.addEventListener('click', event => {
    if (input.value.toLowerCase() == password) {
      toggleSections('show');
      pwWrapper.classList.add('hidden');

      var now = new Date();
      now.setTime(now.getTime() + 1 * (120 * 60) * 1000);
      setCookie(cookieName, true, now);
    } else {
      const error = document.querySelector('.password-protect__error');
      error.classList.remove('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["past-events"]) return;
  try {
    
  const grid = document.querySelector('.past-events__grid');
  const viewMore = document.querySelector('.past-events__view-more');

  if (viewMore) {
    viewMore.addEventListener('click', event => {
      grid.classList.add('show-all');
      viewMore.remove(); 
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-featured-articles"] && !Shopify.designMode) return;
  try {
    
  const featuredArticlesSlider = new Swiper('.featured-articles__container', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20, 
    allowTouchMove: true,
    pagination: {
      el: '.featured-articles__pagination',
      type: 'fraction'
    },
    navigation: {
      prevEl: '.featured-articles .swiper-button-prev',
      nextEl: '.featured-articles .swiper-button-next'
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  var productSliders = [];
  [...document.querySelectorAll('.product-slider__collection')].forEach((el, i) => {
    var handle = '#collection--' + el.dataset.collection;

    productSliders[i] = new Swiper(handle, {
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: 15,
      watchOverflow:  true,
      allowTouchMove: true,
      freeMode: false,
      speed: 350,
      navigation: {
        prevEl: handle + '-arrow-left',
        nextEl: handle + '-arrow-right'
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          slidesPerGroup: 2,
          freeMode: false,
          allowTouchMove: false,
          spaceBetween: 20,
          loop: true 
        },
        1050: {
          slidesPerView: 'auto',
          slidesPerGroup: 3,
          loop: true,
          allowTouchMove: false
        },
        1300: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          loop: true,
          allowTouchMove: false
        },
        1600: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          loop: true,
          allowTouchMove: false
        },
        1900: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          loop: true,
          allowTouchMove: false
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  const announcementBarSlider = new Swiper('.testimonial-slider__slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    navigation: {
      prevEl: '.testimonial-slider .swiper-button-prev',
      nextEl: '.testimonial-slider .swiper-button-next'
    },
    pagination: {
      el: '.testimonial-slider__pagination',
      clickable: true
    },
    speed: 600,
    autoplay: {
      delay: 3000
    }
  });

  } catch(e) { console.error(e); }
})();
})();
